import { Paperclip, FileCheck2 } from 'lucide-react';
import { Button } from '../ui/button';
import { eur } from './api';

export function VehicleFraisList({ vehicle, canAct, onLink, busy }) {
    if (!vehicle) return null;
    const frais = vehicle.frais || [];
    return (
        <div data-testid="invoice-vehicle-frais">
            <div className="flex items-center justify-between mb-1.5">
                <p className="text-[11px] uppercase tracking-wider text-gray-400">Frais déjà dans le dossier ({frais.length})</p>
                <p className="text-[11px] text-gray-500">Marge actuelle <span className="font-mono text-gray-900">{eur(vehicle.marge_ht)}</span> HT</p>
            </div>
            {!frais.length && <p className="text-[12px] text-gray-400">Aucun frais enregistré</p>}
            <ul className="divide-y divide-gray-50 rounded-lg border border-gray-100">
                {frais.map(f => (
                    <li key={f.idx} className="flex items-center gap-2 px-3 py-2 text-[12px]" data-testid={`invoice-frais-${f.idx}`}>
                        <span className="flex-1 min-w-0 truncate text-gray-800">{f.nom || 'Frais'}</span>
                        {f.justificatifs.length > 0
                            ? <span className="inline-flex items-center gap-1 text-[10px] text-emerald-700" title={f.justificatifs.map(j => `${j.fournisseur || ''} ${j.numero_facture || ''}`).join(', ')}><FileCheck2 className="w-3 h-3" />justifié</span>
                            : <span className="text-[10px] text-gray-400">sans justificatif</span>}
                        <span className="font-mono w-20 text-right">{eur(f.montant_ttc)}</span>
                        {canAct && <Button size="sm" variant="outline" disabled={busy} onClick={() => onLink(f)} className="h-7 px-2 text-[11px]" data-testid={`invoice-link-frais-${f.idx}`}><Paperclip className="w-3 h-3 mr-1" />Justificatif</Button>}
                    </li>
                ))}
            </ul>
        </div>
    );
}
